<template>
  <div class="stock-linked-invoices stock-linked-section">
    <v-subheader class="stock-linked-section__title px-0 font-weight-bold">
      {{ title }}
    </v-subheader>
    <v-data-table
      v-if="items.length"
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="-1"
      class="stock-linked-invoices__table stock-linked-table"
    >
      <template v-slot:item.code="{ item }">
        <router-link :to="{ name: 'stock-invoices-view', params: { id: item.id } }">
          {{ displayCode(item) }}
        </router-link>
      </template>
      <template v-slot:item.type="{ item }">
        {{ typeLabel(item.type) }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip small :color="statusColor(item.status)" dark>
          {{ statusLabel(item.status) }}
        </v-chip>
      </template>
      <template v-slot:item.direction="{ item }">
        {{ directionLabel(item.direction) }}
      </template>
    </v-data-table>
    <v-alert v-else type="info" dense text class="mt-2">
      {{ emptyMessage }}
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "StockLinkedInvoicesTable",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    emptyMessage: {
      type: String,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("STOCK.INVOICES.DOCUMENT_CODE"),
          value: "code",
          sortable: false,
        },
        {
          text: this.$t("STOCK.INVOICES.TYPE"),
          value: "type",
          sortable: false,
        },
        {
          text: this.$t("GENERAL.LABELS.STATUS"),
          value: "status",
          sortable: false,
        },
        {
          text: this.$t("STOCK.INVOICES.DIRECTION"),
          value: "direction",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    displayCode(item) {
      if (item.direction === "incoming") {
        return item.external_number || item.code || "-";
      }
      return item.fiscal_number || item.code || "-";
    },
    typeLabel(type) {
      const key = `STOCK.INVOICES.TYPES.${(type || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : type || "-";
    },
    statusLabel(status) {
      const key = `STOCK.STATUSES.INVOICE.${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status || "-";
    },
    statusColor(status) {
      const map = {
        draft: "grey",
        issued: "success",
        paid: "teal",
        cancelled: "error",
      };
      return map[status] || "grey";
    },
    directionLabel(direction) {
      const key = `STOCK.INVOICES.DIRECTIONS.${(direction || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : direction || "-";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/views/partials/stock/stockLinkedTable.scss";

.stock-linked-invoices__table a {
  text-decoration: none;
  font-weight: 500;
}
.stock-linked-invoices__table a:hover {
  text-decoration: underline;
}
</style>
